import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { useState, useCallback } from 'react';
import '../../utils/assertions.es.js';
import { callAllHandlers } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var useDisclosure = function useDisclosure(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      _props$defaultIsOpen = _props.defaultIsOpen,
      defaultIsOpen = _props$defaultIsOpen === void 0 ? false : _props$defaultIsOpen,
      onOpenProp = _props.onOpen,
      onCloseProp = _props.onClose;

  var _useState = useState(defaultIsOpen),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var onOpen = useCallback(function () {
    setIsOpen(true);
    onOpenProp == null ? void 0 : onOpenProp();
  }, [onOpenProp]);
  var onClose = useCallback(function () {
    setIsOpen(false);
    onCloseProp == null ? void 0 : onCloseProp();
  }, [onCloseProp]);
  var onToggle = useCallback(function () {
    isOpen ? onClose() : onOpen();
  }, [isOpen, onClose, onOpen]);
  var getTriggerProps = useCallback(function (props2) {
    if (props2 === void 0) {
      props2 = {};
    }

    return __spreadProps(__spreadValues({}, props2), {
      "aria-expanded": isOpen,
      onClick: callAllHandlers(props2.onClick, onOpen)
    });
  }, [isOpen, onOpen]);

  var getDisclosureProps = function getDisclosureProps(props2) {
    if (props2 === void 0) {
      props2 = {};
    }

    return __spreadValues({}, props2);
  };

  return {
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    getTriggerProps: getTriggerProps,
    getDisclosureProps: getDisclosureProps
  };
};

export { useDisclosure };